// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "artifacts/css/" + chunkId + "." + {"151":"2cef690829f43c1b4185","554":"a2d50a27e91a37dfabf3"}[chunkId] + ".chunk.css";
};